import { createContext } from 'react';
import { FiltersStore } from '../store';
import {
  FilterConfigWithValue,
  FilterData,
  OnChangeFilter,
  OnChangeMultipleFilter,
  RegisterFunction,
} from '../types/filter.types';

export interface FiltersContextProps<
  T extends Record<string, FilterConfigWithValue> = Record<string, FilterConfigWithValue>,
  S = unknown,
> {
  filters: FilterData<T>;
  /**
   *  TODO: NEX-950
      Above FilterData set value as unknown.
      FilterDataTyped<S> type is probably correct, but require refactor ,
      in other components where unknown is casted to some types.
  */
  // filters: FilterDataTyped<S>;
  onChange: OnChangeFilter<T>;
  onChangeMultiple: OnChangeMultipleFilter<T>;
  onRegister: RegisterFunction;
  onResetFilters: () => void;
  onResetSpecificFilter: (filter: keyof FilterData<T>, filters: FilterData<T>) => void;
  onApplyFilters: (filters: FilterData<T>) => void;
  store: FiltersStore<S> | null;
  hasFiltersSelected: boolean;
}

export const FiltersContext = createContext<FiltersContextProps>({} as FiltersContextProps);
